import { render, staticRenderFns } from "./BldPopWin.vue?vue&type=template&id=fb1401f2&scoped=true&"
import script from "./BldPopWin.vue?vue&type=script&lang=js&"
export * from "./BldPopWin.vue?vue&type=script&lang=js&"
import style0 from "./BldPopWin.vue?vue&type=style&index=0&id=fb1401f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb1401f2",
  null
  
)

export default component.exports